import {Directive, TemplateRef} from '@angular/core';

@Directive({
    selector: '[AcDropdownMenuTriggerContent]'
})
export class AcDropdownMenuTriggerContentDirective {
    constructor(public templateRef: TemplateRef<unknown>) {}
}
